import React, { useEffect, useState } from 'react'
import './training.css'
import trainingImg from '../../assets/img/img-background-training2.jpeg'
import logoTraining from '../../assets/img/logo-blancoTPA-Training.png'
import { fetchTraining } from './trainingController'
import { HtmlViewer } from '../htmlViewer/HtmlViewer'
import { UseGetDataSubscribe } from './trainingController'
import { CustomAlert } from '../common/Alert/CustomAlert'
import { getUserStatus } from './trainingController'
import { useToggle } from '../../context/toggle/toggleBtn'
import { LoadingComponent } from '../common/LoadingComponent/LoadingComponent'

export const Training = () => {

    const { toggleClose } = useToggle()

    useEffect(() => {
        document.title = 'TPA® Oficial - TPA Training®'
        toggleClose()
    }, [])


    const [url, setUrl] = useState(null)
    const [description, setDescription] = useState(null)

    const [message, setMessage] = useState('')
    const [status, setStatus] = useState(null)

    // const [showAlert, setShowAlert] = useState(null)

    const [TPATrainingStatus, setTPATrainingStatus] = useState()


    const [alertMessage, setAlertMessage] = useState()
    const [alertColor, setAlertColor] = useState()


    const [loading, setLoading] = useState(true)

    const getStatusMessage = (alertMessage) => {
        const messages = {
            Rejected: {
                text: "Tu solicitud no pudo ser aprobada. Comunicate con administración para que revisemos tu situación.",
                color: "danger"
            },
            PendingForApproval: {
                text: "Ya recibimos tu solicitud. Pronto nos contactaremos.",
                color: "success"
            },
            Locked: {
                text: "Tu suscripción a TPA Training® está temporalmente inactiva. Comunicate con Administración para que juntos revisemos tu situación.",
                color: "warning"
            }
        };

        return messages[alertMessage]
    }



    useEffect(() => {

        const getingStatusMember = async () => {

            try {
                const response = await getUserStatus()

                //console.log('RESPONSE: ', response)
                if (response && response.TPATraining) {

                    setLoading(false)


                    const alertObject = getStatusMessage(response.TPATraining)
                    if (alertObject) {
                        setAlertMessage(alertObject.text)
                        setAlertColor(alertObject.color)
                        setTPATrainingStatus(true)
                    }
                } else {
                    setTPATrainingStatus(false)

                    //? setTimeOut necesario para cargar las imagenes de la pagina 
                    setTimeout(() => {
                        setLoading(false);
                    }, 1500);
                }

            } catch (error) {
                setLoading(false)
            }

        }

        getingStatusMember()

    }, [])




    //? envia la peticion a "quiero entrenarme" y setea los datos para el toast 

    const getResponseSubscribe = async () => {

        const response = await UseGetDataSubscribe()

        if (response) {
            //console.log('response training::: ', response)

            setMessage(response.data.message)
            setStatus(response.status)
            // setShowAlert(true)


            const alertObject = getStatusMessage('PendingForApproval')
            if (alertObject) {
                setAlertMessage(alertObject.text)
                setAlertColor(alertObject.color)
                setTPATrainingStatus(true)
            }

        }
    }



    //? Datos para el htmlViewer
    useEffect(() => {
        const getTraining = async () => {
            try {
                const response = await fetchTraining()
                //console.log('response training componente: ', response)
                if (response) {

                    setUrl(response.data.data.urlService)
                    setDescription(response.data.data.description)
                }
            } catch (error) {
                // console.error(error)
            }
        };

        getTraining()
    }, [])

    const smoothScrollUp = () => {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100); // Pequeño delay para asegurar que se ejecuta después de la actualización del DOM
    };


    return (

        <>{loading
            ?
            <LoadingComponent />
            :

            <>
                <div className='training-container'>

                    <div className='training-too-scroll'>

                        <div className="training-logo-container">
                            <img src={logoTraining} alt="" />
                        </div>

                        <CustomAlert toShow={TPATrainingStatus} text={alertMessage} color={alertColor} />

                        <div className="sub-training-container">
                            <div className="img-training-container">
                                <img className='training-img' src={trainingImg} alt="trainingImg" />
                            </div>

                            <div className="text-training-container">
                                {/* <p className='training-text'>¿Querés llevar tu entrenamiento físico y tus conocimientos sobre cómo armar tus clases TPA® al siguiente nivel?

                            ¡Te acercamos TPA TRAINING®!

                            Sistema que te permitirá participar de 8 clases mensuales ON-LINE , brindadas por el Staff TPA® de entrenamiento audiovisual. Contenido supervisado por la autora TPA®, Lic. Silvina Lambertini.

                            * Podrás abonar el pack mensual antes del inicio de cada mes y seleccionar en el turnero las 8 clases en las que querés participar.
                            * Total flexibilidad para elegir días y horarios entre las opciones disponibles.
                            * 50 minutos de clase + 10 minutos de consultas, dudas y debates.

                            Hacé click en “QUIERO ENTRENARME” y te recibiremos con los brazos abiertos para llevarte al máximo de tus capacidades.

                            TPA TRAINING®</p> */}
                                {description ? <HtmlViewer content={description} /> : null}
                            </div>
                        </div>

                    </div>


                </div>
                {TPATrainingStatus === null
                    ?
                    null
                    :
                    TPATrainingStatus === false ?

                        <div className={`button-training-container ${TPATrainingStatus ? 'd-none' : 'd-flex'} `}>

                            <button
                                className='training-button'
                                type='submit'
                                onClick={() => {
                                    getResponseSubscribe();
                                    const container = document.getElementsByClassName('cont-secundario')[0];
                                    container.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                }}>
                                QUIERO ENTRENARME!!!
                            </button>

                        </div>

                        : null
                }
            </>
        }</>

    )
}
